export default {"src":"/_next/static/media/charm_refresh.cf36363a.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};